export const createSolutionSchema = ({ getPacketVolumeString, getPacketCostString }) => {
  return {
    title: 'Solution Details',
    summary: {
      title: 'Details',
      fields: [
        { key: 'name', label: 'Name' },
        {
          key: 'packetVolume',
          label: 'Packet Volume',
          getValue: (row) => getPacketVolumeString(row),
        },
        {
          key: 'packetCost',
          label: 'Packet Cost',
          getValue: (row) => getPacketCostString(row),
        },
      ],
    },
    sections: [
      {
        title: 'Notes',
        fields: [{ key: 'notes', label: 'Notes' }],
      },
    ],
  };
};

